import { render } from "./xieyi.vue?vue&type=template&id=156711e9&scoped=true&ts=true"
import script from "./xieyi.vue?vue&type=script&lang=ts"
export * from "./xieyi.vue?vue&type=script&lang=ts"

import "./xieyi.vue?vue&type=style&index=0&id=156711e9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/nonbid_zlysz_com_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156711e9"]])

export default __exports__